var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
export var CardContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  perspective: ", ";\n  height: 100%;\n  width: 100%;\n"], ["\n  perspective: ", ";\n  height: 100%;\n  width: 100%;\n"])), function (_a) {
    var $isFlipped = _a.$isFlipped;
    return ($isFlipped ? '1000px' : 'unset');
});
export var Flipper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  position: relative;\n  width: 100%;\n"], ["\n  height: 100%;\n  position: relative;\n  width: 100%;\n"])));
export var CommonCardStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  transition: 0.6s;\n"], ["\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  transition: 0.6s;\n"])));
export var FrontContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  position: ", ";\n  transform: ", ";\n  transform-style: ", ";\n  ", "\n"], ["\n  ", "\n  position: ", ";\n  transform: ", ";\n  transform-style: ", ";\n  ", "\n"])), CommonCardStyles, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return ($isFlipped ? 'absolute' : 'relative');
}, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return ($isFlipped ? 'rotateY(-180deg)' : 'unset');
}, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return $isFlipped ? 'preserve-3d' : 'unset';
}, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return $isFlipped && 'visibility: hidden;';
});
export var BackContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  position: ", ";\n  transform: ", ";\n  transform-style: preserve-3d;\n  ", "\n"], ["\n  ", "\n  position: ", ";\n  transform: ", ";\n  transform-style: preserve-3d;\n  ", "\n"])), CommonCardStyles, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return ($isFlipped ? 'relative' : 'absolute');
}, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return $isFlipped ? 'rotateY(0deg)' : 'rotateY(180deg)';
}, function (_a) {
    var $isFlipped = _a.$isFlipped;
    return !$isFlipped && 'visibility: hidden;';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
